import React from 'react';
import {
    Box,
    Button,
    Flex,
    IconButton,
    ScrollArea,
    Select,
    TextField,
    Text,
} from '@radix-ui/themes';
import { FormField } from 'shared/components';
import { AddIcon, ClearIcon } from 'shared/icons';
import { observer } from 'mobx-react-lite';
import { useCreateResumeContext } from 'candidate/feature-create-resume/create-resume.context';

const LinkedSocialsView = () => {
    const { contactInfoStore } = useCreateResumeContext();
    const linkedSocials = contactInfoStore.linkedSocials;
    // const validation = FormService.validate<{
    //     messengers: string[];
    //     control: MessengerControl;
    // }>(
    //     {
    //         control: contactInfoCtx.messengerControl,
    //         messengers: contactInfoCtx.messengers,
    //     },
    //     MessengerValidationSchema
    // );

    return (
        <Box className="messengers-list-container">
            <Flex gap="4" align="end">
                <FormField label="Мессенджер">
                    <Select.Root
                        size="3"
                        value={linkedSocials.socialControl.selectValue}
                        onValueChange={(value) =>
                            linkedSocials.socialControl.onSelectChange(value)
                        }
                    >
                        <Select.Trigger></Select.Trigger>
                        <Select.Content position="popper">
                            {linkedSocials
                                .availableSocials(linkedSocials.socialControl)
                                .map((messenger) => {
                                    return (
                                        <Select.Item key={messenger} value={messenger}>
                                            {messenger}
                                        </Select.Item>
                                    );
                                })}
                        </Select.Content>
                    </Select.Root>
                </FormField>

                <FormField label="Імʼя користувача або номер телефону">
                    <TextField.Root
                        size="3"
                        value={linkedSocials.socialControl.inputValue}
                        onChange={(e) => {
                            linkedSocials.socialControl.onInputChange(e.target.value);
                        }}
                    ></TextField.Root>
                </FormField>

                <Button
                    size="3"
                    variant="outline"
                    type="button"
                    onClick={() => linkedSocials.addSocial()}
                >
                    <Text weight="regular">Додати ще</Text>
                    <AddIcon />
                </Button>
            </Flex>

            <Box pt="4">
                <ScrollArea scrollbars="vertical" type="always" style={{ maxHeight: 200 }}>
                    <Flex gap="4" direction="column">
                        {linkedSocials.socailsControls.map((control) => {
                            return (
                                <Flex gap="4" pr="100px" align="end" key={control.id}>
                                    <FormField label="Мессенджер">
                                        <Select.Root
                                            size="3"
                                            value={control.selectValue}
                                            onValueChange={(value) => {
                                                control.onSelectChange(value);
                                            }}
                                        >
                                            <Select.Trigger></Select.Trigger>
                                            <Select.Content position="popper">
                                                {linkedSocials
                                                    .availableSocials(control)
                                                    .map((messenger) => {
                                                        return (
                                                            <Select.Item
                                                                key={messenger}
                                                                value={messenger}
                                                            >
                                                                {messenger}
                                                            </Select.Item>
                                                        );
                                                    })}
                                            </Select.Content>
                                        </Select.Root>
                                    </FormField>

                                    <FormField label="Імʼя користувача або номер телефону">
                                        <TextField.Root
                                            value={control.inputValue}
                                            onChange={(e) => {
                                                control.onInputChange(e.target.value);
                                            }}
                                            size="3"
                                        ></TextField.Root>
                                    </FormField>

                                    <IconButton
                                        size="3"
                                        type="button"
                                        variant="outline"
                                        onClick={() => linkedSocials.removeSocial(control.id)}
                                    >
                                        <ClearIcon />
                                    </IconButton>
                                </Flex>
                            );
                        })}
                    </Flex>
                </ScrollArea>
            </Box>
        </Box>
    );
};

export const LinkedSocials = observer(LinkedSocialsView);
